/**
 * @typedef {Object} MatomoConfig
 * @property {string|null} siteId
 * @property {string|null} matomoUrl
 */

import {CookieConsent} from '../CookieConsent/CookieConsent';

export class Matomo {

    /**
     * @type {MatomoConfig}
     */
    config = {};

    /**
     * @type {string}
     */
    trackerUrl = 'piwik.js';

    /**
     * @param {MatomoConfig} config
     */
    constructor(config = {}) {
        if (
            !config
            || !config.siteId
            || !config.matomoUrl
        ) {
            console.warn('Matomo: Invalid config.', { config });
            return;
        }

        this.config = config;
        this.setupEventHandler();

        if (this.hasValidConsent()) {
            this.enableTracking();
        }
    }

    /**
     * Add event handlers.
     *
     * @protected
     */
    setupEventHandler() {
        // Listen for consent updates to dynamically toggle tracking.
        document.addEventListener('cookieConsentUpdated', () => {
            if (this.hasValidConsent()) {
                this.enableTracking();
            } else {
                this.disableTracking();
            }
        });
    }

    /**
     * Check consent from CookieConsent.
     *
     * @returns {boolean}
     */
    hasValidConsent() {
        const consent = CookieConsent.getConsent();

        return !!(
            consent
            && consent.analyzing
        );
    }

    /**
     * Enable Matomo tracking.
     */
    enableTracking() {
        // Check explicitly if the script already exists
        if (document.querySelector(`script[src*="${this.trackerUrl}"]`)) {
            return;
        }

        const _paq = (window._paq = window._paq || []);
        _paq.push(['setDoNotTrack', '1']);
        _paq.push(['setCustomVariable', 1, 'Browserviewport', window.outerWidth + 'x' + window.outerHeight, 'visit']);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        _paq.push(['disableCookies']);

        const ensureSingleTrailingSlash = (str) => str.replace(/\/+$/, '') + '/';
        (function () {
            const u = `//${ensureSingleTrailingSlash(this.config.matomoUrl)}`;
            _paq.push(['setTrackerUrl', u + 'piwik.php']);
            _paq.push(['setSiteId', this.config.siteId]);
            const d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.src = u + this.trackerUrl;
            s.parentNode.insertBefore(g, s);
        }).bind(this)();
    }

    /**
     * Disable Matomo tracking.
     */
    disableTracking() {
        if ('_paq' in window) {
            delete window._paq;
        }

        // Check explicitly if the script already exists
        document.querySelectorAll(`script[src*="${this.trackerUrl}"]`).forEach((script) => {
            script.remove();
        });
    }
}
